module.exports = {"title":"Your Accounts Are Now Connected","closeCta":"Close"}


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/Facebook/facebookConfirmationModalCopy.json
// module id = 2629
// module chunks = 62